/* Frenky S bovenbalk collectiepagina's: Heren/Kids-switch + Filteren/Sorteren. Eén controller per pagina. */
(function(){
  var S = window.FSDG || (window.FSDG = {});
  if(S.loaded) return;
  S.loaded = true;
  var d = document.documentElement;
  var LABEL_ALL = 'Toon weer alles';
  var CHEV = '<svg class="dg-dd__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4"/></svg>';
  var MQ = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
  S.catmap = {};
  S.fetched = {};
  function wrap(){ return document.querySelector('.dg-wrap'); }
  function filt(){ return document.querySelector('[data-dg-filter]'); }
  function mode(){ return d.getAttribute('data-dg') || 'beide'; }
  function cats(){ var v = d.getAttribute('data-cat') || ''; return v ? v.split(',').filter(Boolean) : []; }
  function grid(){ return document.querySelector('.cn-grid'); }
  function next(k){ return mode() === k ? 'beide' : k; }
  function esc(t){ var x = document.createElement('div'); x.textContent = t; return x.innerHTML; }
  function urlFor(m, list){
    var u = new URL(window.location.href);
    u.searchParams.delete('page');
    if(m === 'beide'){ u.searchParams.delete('voor'); } else { u.searchParams.set('voor', m); }
    if(!list.length){ u.searchParams.delete('categorie'); } else { u.searchParams.set('categorie', list.join(',')); }
    return u.pathname + u.search.replace(/%2C/gi, ',') + u.hash;
  }
  function hrefOf(card){
    var a = card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : '';
  }
  function isOwn(n){ return n.nodeType !== 1 || (n.classList && n.classList.contains('dg-tile')); }
  function readMap(){
    var w = wrap(), el = w ? w.querySelector('[data-dg-catmap]') : null;
    try { S.catmap = el ? JSON.parse(el.textContent) : {}; } catch(e){ S.catmap = {}; }
  }
  function target(){
    var nav = document.querySelector('.dg-wrap .dg-switch');
    if(nav && (!MQ || MQ.matches)){
      var t = nav.querySelector('.dg-tools');
      if(!t){ t = document.createElement('div'); t.className = 'dg-tools'; nav.appendChild(t); }
      return t;
    }
    return document.querySelector('.cn-toolbar__right');
  }
  function placeTools(){
    var t = target(); if(!t) return;
    var f = filt(), so = document.querySelector('[data-dg-sort]');
    if(f && f.parentNode !== t){ t.insertBefore(f, t.firstChild); }
    if(so && so.parentNode !== t){ t.appendChild(so); }
    if(so && f && f.nextSibling !== so){ t.insertBefore(f, so); }
  }
  function setup(){
    var all = document.querySelectorAll('[data-dg-filter]');
    if(all.length){
      var fresh = all[all.length - 1];
      for(var i = 0; i < all.length; i++){ if(all[i] !== fresh && all[i].parentNode){ all[i].parentNode.removeChild(all[i]); } }
      var b = fresh.querySelector('.dg-filter__btn');
      if(b && !b.querySelector('.dg-dd__main')){
        var lbl = (b.textContent || 'Filteren').trim();
        b.innerHTML = '<span class="dg-dd__main">' + ICON + '<span>' + esc(lbl) + '</span><span class="dg-filter__n" data-dg-fcount></span></span>' + CHEV;
      }
      var p = fresh.querySelector('.dg-filter__panel'); if(p){ p.style.minWidth = '300px'; }
      fresh.hidden = false;
    }
    if(wrap()){ buildSort(); }
    placeTools();
  }
  function nativeSel(){ return document.querySelector('.cn-sort select'); }
  function buildSort(){
    var sel = nativeSel();
    if(!sel) return;
    var old = document.querySelector('[data-dg-sort]'); if(old){ old.parentNode.removeChild(old); }
    var el = document.createElement('div');
    el.className = 'dg-filter dg-sortdd';
    el.setAttribute('data-dg-sort', '');
    var cur = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : '';
    var opts = '';
    [].forEach.call(sel.options, function(o){ opts += '<button type="button" class="dg-sort__opt' + (o.selected ? ' is-on' : '') + '" data-dg-sortv="' + esc(o.value) + '">' + esc(o.text) + '</button>'; });
    el.innerHTML = '<button type="button" class="dg-filter__btn" aria-expanded="false"><span class="dg-dd__main"><span>Sorteren</span><span class="dg-dd__val">' + esc(cur) + '</span></span>' + CHEV + '</button>'
      + '<div class="dg-filter__backdrop" data-dg-fclose hidden></div>'
      + '<div class="dg-filter__panel" role="dialog" aria-label="Sorteren" hidden><div class="dg-filter__head"><span>Sorteren</span><button type="button" class="dg-filter__close" data-dg-fclose aria-label="Sluiten">&times;</button></div><div class="dg-filter__list">' + opts + '</div></div>';
    document.body.appendChild(el);
    d.classList.add('dg-has-sort');
  }
  function setOpen(el, open){
    if(!el) return;
    if(open){ document.querySelectorAll('.dg-filter.is-open').forEach(function(o){ if(o !== el){ setOpen(o, false); } }); }
    var p = el.querySelector('.dg-filter__panel'), bd = el.querySelector('.dg-filter__backdrop'), b = el.querySelector('.dg-filter__btn');
    el.classList.toggle('is-open', open);
    if(p) p.hidden = !open;
    if(bd) bd.hidden = !open;
    if(b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll(){ document.querySelectorAll('.dg-filter.is-open').forEach(function(o){ setOpen(o, false); }); }
  function nextUrl(root){
    var s = root.querySelector('.cn-sentinel[data-next]');
    var v = s ? (s.getAttribute('data-next') || '').trim() : '';
    return (v && v.indexOf('page=') > -1) ? v : '';
  }
  function loadAll(){
    if(S.loading) return;
    var g = grid(), url = nextUrl(document);
    if(!g || !url || S.fetched[url]) return;
    S.loading = true;
    var sen = document.querySelector('.cn-sentinel');
    if(sen){ sen.parentNode.removeChild(sen); }
    var seen = {};
    g.querySelectorAll('.cn-card').forEach(function(c){ seen[hrefOf(c)] = 1; });
    (function step(u, guard){
      if(!u || S.fetched[u] || guard > 20){ S.loading = false; render(); return; }
      S.fetched[u] = 1;
      fetch(u, { credentials:'same-origin' }).then(function(r){ return r.text(); }).then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var frag = document.createDocumentFragment();
        doc.querySelectorAll('.cn-grid .cn-card').forEach(function(c){
          var h = hrefOf(c);
          if(h && !seen[h]){ seen[h] = 1; frag.appendChild(document.importNode(c, true)); }
        });
        g.appendChild(frag);
        step(nextUrl(doc), guard + 1);
      }).catch(function(){ S.loading = false; });
    })(url, 0);
  }
  function render(){
    var w = wrap();
    if(!w) return;
    var m = mode(), list = cats();
    w.querySelectorAll('[data-dg-btn]').forEach(function(b){
      var k = b.getAttribute('data-dg-btn'), on = (m === k);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if(on){ b.setAttribute('title', LABEL_ALL); } else { b.removeAttribute('title'); }
      b.setAttribute('href', urlFor(next(k), list));
    });
    var g = grid();
    if(g){
      if(S.mo){ S.mo.disconnect(); }
      [].slice.call(document.querySelectorAll('.dg-tile')).forEach(function(n){ n.parentNode.removeChild(n); });
      var all = [].slice.call(g.querySelectorAll('.cn-card'));
      var hasMap = Object.keys(S.catmap).length > 0;
      all.forEach(function(card){ card.classList.toggle('dg-cat-hide', !!(hasMap && list.length && list.indexOf(S.catmap[hrefOf(card)] || '') === -1)); });
      var cards = all.filter(function(el){ return window.getComputedStyle(el).display !== 'none'; });
      if(m !== 'beide' && !list.length){
        [].slice.call(w.querySelectorAll('template[data-dg-tile]'))
          .filter(function(t){ return t.getAttribute('data-for') === m; })
          .sort(function(a, b){ return (+a.getAttribute('data-pos')) - (+b.getAttribute('data-pos')); })
          .forEach(function(t){
            var node = t.content.firstElementChild.cloneNode(true);
            var tg = cards[(+t.getAttribute('data-pos')) - 1];
            if(tg){ g.insertBefore(node, tg); } else { g.appendChild(node); }
          });
      }
      if(m !== 'beide' || list.length){
        var cnt = document.querySelector('.cn-grid__count');
        if(cnt){ cnt.textContent = cnt.textContent.replace(/^\s*\d+/, String(cards.length)); }
      }
      var f = filt();
      if(f){
        f.classList.toggle('has-active', list.length > 0);
        var n = f.querySelector('[data-dg-fcount]'); if(n){ n.textContent = list.length ? String(list.length) : ''; }
        var r = f.querySelector('[data-dg-fresult]'); if(r){ r.textContent = String(cards.length); }
        f.querySelectorAll('[data-dg-cat-check]').forEach(function(cb){ cb.checked = list.indexOf(cb.value) > -1; });
      }
      if(!S.mo){
        S.mo = new MutationObserver(function(recs){
          var real = recs.some(function(rr){
            return [].some.call(rr.addedNodes, function(x){ return !isOwn(x); }) || [].some.call(rr.removedNodes, function(x){ return !isOwn(x); });
          });
          if(!real) return;
          clearTimeout(S.t); S.t = setTimeout(render, 80);
        });
      }
      S.mo.observe(g, { childList:true });
    }
    if(m !== 'beide' || list.length){ loadAll(); }
  }
  S.render = render;
  function go(m, list){
    var url = urlFor(m, list);
    d.setAttribute('data-dg', m);
    if(list.length){ d.setAttribute('data-cat', list.join(',')); } else { d.removeAttribute('data-cat'); }
    try { history.replaceState(history.state, '', url); } catch(err){}
    render();
    try { document.dispatchEvent(new CustomEvent('frenky:doelgroep', { detail:{ mode:m, categorie:list.join(',') } })); } catch(err){}
  }
  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var btn = e.target.closest('.dg-filter__btn');
    if(btn){ e.preventDefault(); var dd = btn.closest('.dg-filter'); setOpen(dd, !dd.classList.contains('is-open')); return; }
    if(e.target.closest('[data-dg-fclose]')){ e.preventDefault(); closeAll(); return; }
    if(e.target.closest('[data-dg-fclear]')){ e.preventDefault(); go(mode(), []); return; }
    var so = e.target.closest('[data-dg-sortv]');
    if(so){
      e.preventDefault();
      var sel = nativeSel();
      if(sel){ sel.value = so.getAttribute('data-dg-sortv'); sel.dispatchEvent(new Event('change', { bubbles:true })); }
      closeAll();
      return;
    }
    if(!e.target.closest('.dg-filter')){ closeAll(); }
    if(e.metaKey || e.ctrlKey || e.shiftKey) return;
    var b = e.target.closest('.dg-wrap [data-dg-btn]');
    if(b){ e.preventDefault(); go(next(b.getAttribute('data-dg-btn')), cats()); }
  });
  document.addEventListener('change', function(e){
    var cb = e.target;
    if(!cb || !cb.matches || !cb.matches('[data-dg-cat-check]')) return;
    var list = cats().filter(function(x){ return x !== cb.value; });
    if(cb.checked){ list.push(cb.value); }
    var order = [].map.call(document.querySelectorAll('[data-dg-cat-check]'), function(x){ return x.value; });
    list.sort(function(a, b){ return order.indexOf(a) - order.indexOf(b); });
    go(mode(), list);
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ closeAll(); } });
  if(MQ){ var onMq = function(){ closeAll(); placeTools(); }; if(MQ.addEventListener){ MQ.addEventListener('change', onMq); } else if(MQ.addListener){ MQ.addListener(onMq); } }
  document.addEventListener('shopify:section:load', function(){ clearTimeout(S.t); S.t = setTimeout(function(){ if(S.mo){ S.mo.disconnect(); S.mo = null; } S.fetched = {}; readMap(); setup(); render(); }, 60); });
  document.addEventListener('shopify:block:select', function(e){
    var id = e.detail && e.detail.blockId;
    if(!id) return;
    var t = document.querySelector('template[data-dg-tile][data-block-id="' + id + '"]');
    if(!t) return;
    d.setAttribute('data-dg', t.getAttribute('data-for'));
    d.removeAttribute('data-cat');
    render();
    var n = document.querySelector('.dg-tile[data-block-id="' + id + '"]');
    if(n){ n.scrollIntoView({ block:'center', behavior:'smooth' }); }
  });
  function init(){ readMap(); setup(); render(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();